import { EmptySection } from './empty-section';

export class DoubleDutchEmptySection extends EmptySection {
  public borderColor: string;
  public backgroundColor: string;
}
